<script>
  import { Elements, PaymentElement, Address, ExpressCheckout } from 'svelte-stripe'
  import Success from './Success.svelte'

  let {
    stripe,
    clientSecret,
    paymentError = $bindable(null),
    submitDonation,
    successHeadline = '',
    successContent = '',
    onback,
  } = $props()

  let elements = $state()
  let submitting = $state(false)
  let paid = $state(false)
  let successEl = $state(null)

  $effect(() => {
    if (paid && successEl) {
      successEl.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  })

  const appearance = {
    theme: 'stripe',
    labels: 'floating',
    variables: {
      colorPrimary: '#0448c5',
      colorBackground: '#ffffff',
      colorText: '#18191a',
      colorDanger: '#ef4444',
      fontFamily: '"neue-haas-grotesk-display", sans-serif',
      fontSizeBase: '16px',
      borderRadius: '6px',
    },
    rules: {
      '.Input': {
        fontSize: '16px',
        padding: '10px 20px',
        border: '1px solid #d9d9d9',
        boxShadow: 'none',
        transition: 'border-color 0.15s ease',
      },
      '.Input:focus': {
        border: '1px solid #0448c5',
        boxShadow: 'none',
        outline: 'none',
      },
      '.Input--invalid': {
        border: '1px solid #ef4444',
        boxShadow: 'none',
      },
      '.Input::placeholder': {
        color: '#8a8d92',
      },
      '.Label--resting': {
        color: '#8a8d92',
      },
      '.Label--floating': {
        color: '#18191a',
      },
    },
  }

  async function runConfirmation({ submitFirst } = { submitFirst: false }) {
    submitting = true
    paymentError = null

    if (submitFirst) {
      const { error: submitError } = await elements.submit()
      if (submitError) {
        paymentError = submitError.message
        submitting = false
        return
      }
    }

    const result = await stripe.confirmPayment({
      elements,
      clientSecret,
      confirmParams: { return_url: window.location.href },
      redirect: 'if_required',
    })

    if (result.error) {
      paymentError = result.error.message
      submitting = false
      return
    }

    if (result.paymentIntent?.status === 'succeeded') {
      try {
        const ok = await submitDonation(result.paymentIntent.id)
        if (ok) {
          paid = true
        } else {
          paymentError = 'Payment succeeded but recording failed. Please contact us.'
          submitting = false
        }
      } catch (err) {
        paymentError = 'Payment succeeded but recording failed. Please contact us.'
        submitting = false
      }
    } else {
      submitting = false
    }
  }

  function handleSubmit() {
    if (!stripe || !elements || !clientSecret || submitting) return
    runConfirmation({ submitFirst: true })
  }

  function handleExpressConfirm() {
    if (!stripe || !elements || !clientSecret || submitting) return
    runConfirmation({ submitFirst: false })
  }
</script>

{#if paid}
  <div bind:this={successEl}>
    <Success headline={successHeadline} content={successContent} />
  </div>
{:else}
  <div>
    <h2 class="font-bold uppercase text-primary text-h4 em-secondary">
      <span>Payment</span> Details
    </h2>
  </div>

  <div class="min-h-[500px]">
    {#if stripe && clientSecret}
      <Elements {stripe} {clientSecret} {appearance} bind:elements>
        <div class="mt-6">
          <ExpressCheckout onconfirm={handleExpressConfirm} />
        </div>
        <div class="mt-6">
          <Address mode="billing" />
        </div>
        <div class="mt-6">
          <PaymentElement />
        </div>
      </Elements>
    {:else}
      <div class="grid place-items-center h-full min-h-[500px]">
        <svg class="animate-spin size-10 text-primary" viewBox="0 0 24 24" fill="none" aria-label="Loading payment" role="img">
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.2" stroke-width="3" />
          <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        </svg>
      </div>
    {/if}
  </div>

  {#if paymentError}
    <p class="form-field-message bad">{paymentError}</p>
  {/if}

  <div class="my-8 space-y-4 text-center">
    <button type="button" class="mt-8 w-full btn btn-fill-secondary" disabled={submitting} onclick={handleSubmit}>
      {submitting ? 'Processing…' : 'Submit Donation'}
    </button>
    <button type="button" class="inline-block p-4 underline transition-colors xl:text-xl text-primary hover:text-secondary" onclick={onback} disabled={submitting}>Back</button>
  </div>
{/if}
